import WPAPI from 'wpapi';

const applicationPassword = process.env.REACT_APP_WORDPRESS_APPLICATION_PASSWORD;
const userName = process.env.REACT_APP_WORDPRESS_APPLICATION_USERNAME;

const wp = new WPAPI({
  endpoint: 'https://www.flex-key.com/wp-json/',
  username: userName,
  password: applicationPassword,
  auth: true
});

wp.customOrder = wp.registerRoute('wporders/v1', '/author/(?P<id>\\d+)');

// eslint-disable-next-line import/prefer-default-export
export async function createUser(
  username,
  email,
  password,
  first_name = '',
  last_name = ''
) {
  wp.users()
    .create({
      username, email, password, first_name, last_name, roles: ['customer', 'subscriber']
    });
}

export async function checkUser(userId) {
  const user = wp.users().id(userId);
  return user;
}

export function createSaveCustomPost(post) {
  const order = wp.customOrder().create(post);
  return order;
}
